import http from 'hub-http/clients/apiClient';
export const fetchThreadDetails = ({
  threadId
}) => {
  return http.get(`messages/v2/threadlist/member/${threadId}/details`);
};